<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import type { PrimitiveProps } from 'reka-ui'

import { cn } from 'cn'
import { Primitive } from 'reka-ui'

import type { MarkerVariants } from './variants'

import { markerVariants } from './variants'

interface Props extends PrimitiveProps {
  variant?: MarkerVariants['variant']
  class?: HTMLAttributes['class']
}

const props = withDefaults(defineProps<Props>(), {
  as: 'div',
})
</script>

<template>
  <Primitive
    data-slot="marker"
    :data-variant="variant"
    :as
    :as-child
    :class="cn(markerVariants({ variant }), props.class)"
  >
    <slot />
  </Primitive>
</template>
